import React from 'react';
import type { CSSProperties } from 'react';
import { Box, LoadingOverlay, Stack, Text } from '@mantine/core';
import { GanttChartLoader } from './GanttChartLoader';

/** Blocks interaction on task add/delete modals while the Gantt store update runs. */
export function TaskModalBusyOverlay({
  busy,
  label,
  children,
  style,
}: {
  busy: boolean;
  label: string;
  children: React.ReactNode;
  style?: CSSProperties;
}) {
  return (
    <Box pos="relative" style={style}>
      <LoadingOverlay
        visible={busy}
        zIndex={1000}
        overlayProps={{ radius: 'sm', blur: 2 }}
        loaderProps={{
          children: (
            <Stack align="center" gap="xs">
              <GanttChartLoader size="sm" />
              <Text size="sm" fw={500}>
                {label}
              </Text>
            </Stack>
          ),
        }}
      />
      {children}
    </Box>
  );
}
